import React from 'react';
import PropTypes from 'prop-types';

import './Separator.css';

const Separator = ({ style, className }) => <div name="Separator" style={style} className={className} />;

Separator.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string
};

Separator.defaultProps = {
  style: {},
  className: ''
};

export default Separator;
